import Layout from '@/layout'

const repairPlatformRouter = {
  path: '/repairPlatform',
  component: Layout,
  name: 'RepairPlatform',
  meta: {
    title: 'routeRepairPlatform',
    icon: 'frame16'
  },
  children: [
    // 维修信息公开咨询
    {
      path: 'repairInfoConsulting',
      component: () => import('@/views/repairPlatform/repairInfo/repairInfoConsulting'),
      name: 'RepairInfoConsulting',
      meta: { title: 'routeRepairInfoConsulting', icon: 'frame16', code: 'io:consult:managepage' }
    },
    {
      path: 'repairInfoConsultingList',
      component: () => import('@/views/repairPlatform/repairInfo/repairInfoConsultingList'),
      name: 'RepairInfoConsultingList',
      meta: { title: 'routeRepairInfoConsultingList', icon: 'frame16', code: 'io:consult:managepage' },
      hidden: true
    },
    {
      path: 'repairInfoAdminInfo/:id',
      component: () => import('@/views/repairPlatform/repairInfo/repairInfoAdminInfo'),
      name: 'RepairInfoAdminInfo',
      meta: { title: 'routeRepairInfoConsultingDetails', icon: 'clipboard', noCache: true, activeMenu: '/repairPlatform/repairInfo/repairInfoAdminInfo', code: 'io:consult:managepage' },
      hidden: true
    },
    {
      path: 'repairInfoInfo/:id',
      component: () => import('@/views/repairPlatform/repairInfo/repairInfoInfo'),
      name: 'RepairInfoInfo',
      meta: { title: 'routeRepairInfoConsultingDetails', icon: 'clipboard', noCache: true, activeMenu: '/repairPlatform/repairInfo/repairInfoInfo', code: 'io:consult:managepage' },
      hidden: true
    },
    // 维修公开平台通用信息
    {
      path: 'generalInfo',
      component: () => import('@/views/repairPlatform/generalInfo/generalInfo'),
      name: 'RepairGeneralInfo',
      meta: { title: 'routeRepairGeneralInfo', icon: 'generalInfo', code: 'general:info:page' }
    },
    // 会员管理
    {
      path: 'sysMember',
      component: () => import('@/views/repairPlatform/sys-member/sys-member-list'),
      name: 'SysMember',
      meta: { title: 'routeSysMember', icon: 'member', code: 'sys:member:page' }
    }
  ]
}

export default repairPlatformRouter 
